module.exports = __webpack_public_path__ + "media/images/mobile/Slider8-38b9ebb22175d0f81afca1cfa24ca72c.png";